import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputCargoContato = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { cargo } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("cargo")
    }

    return (
        <CampoInputTexto
        id="inputCargo"
        titulo="Cargo contato"
        onChange={handleChange}
        name="cargo"
        value={cargo}
        disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputCargoContato
